// src/utils/native.js
// Filepath: // src/utils/native.js
// Wrapper around your Android WebView JS interface (window.Android).
// Includes safe browser fallbacks (Wake Lock) for local dev.

let _wakeLock = null;

async function requestWakeLock() {
  try {
    if ("wakeLock" in navigator && !_wakeLock) {
      _wakeLock = await navigator.wakeLock.request("screen");
      _wakeLock.addEventListener?.("release", () => { _wakeLock = null; });
    }
  } catch { /* noop in browsers that don't support it */ }
}
async function releaseWakeLock() {
  try { await _wakeLock?.release?.(); } catch {}
  _wakeLock = null;
}

export const Native = {
  disableScreensaver() {
    try { window.Android?.disableScreensaver?.(); } catch {}
    // Dev/browser fallback
    requestWakeLock();
  },
  enableScreensaver() {
    try { window.Android?.enableScreensaver?.(); } catch {}
    // Dev/browser fallback
    releaseWakeLock();
  },
  exitApp() {
    try { window.Android?.exitApp?.(); } catch {
      try { window.close?.(); } catch {}
    }
  },
};
